var map = {
	"./bg0.png": "uJ9h",
	"./bg5.png": "Kl+4",
	"./bg6.png": "3bBE",
	"./bg7.png": "dlDM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KWke";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home ^\.\/bg.*\.png$
// module id = KWke
// module chunks = 1